import { busSeatSelectionConstants } from './../constants/bus-seat-selection.constants'

const initialState = {
	busSeatsGoing: [],
	poltronasIda: [],
	busSeatsReturn: [],
	poltronasVolta: [],
	totalSeatsGoing: 0,
	totalSeatsReturn: 0,
}

export default function busSeatSelectionReducer(state = initialState, action) {
	switch (action.type) {
		case busSeatSelectionConstants.SELECT_BUS_SEAT_GOING:
			let seatBusSelected = action.payload
			let newBusSeatsGoing = []

			let updateBusSeatsGoing = state.busSeatsGoing.map((seat) => {
				if (seat.number === seatBusSelected.number) {
					let updatedSeat = {
						...seat,
						...seatBusSelected,
						available: false,
					}

					if (!!seatBusSelected.conexao) {
						updatedSeat.dataViagem = seatBusSelected.conexao.departure
						updatedSeat.ordem = seatBusSelected.conexao.ordem
					}

					newBusSeatsGoing.push(updatedSeat)

					return updatedSeat
				}

				return seat
			})

			return {
				...state,
				busSeatsGoing: updateBusSeatsGoing,
				poltronasIda: [...state.poltronasIda, ...newBusSeatsGoing],
			}
		case busSeatSelectionConstants.DESELECT_BUS_SEAT_GOING:
			if (
				action.payload.conexao != null &&
				action.payload.conexao.ehConexaoIda
			) {
				var conexaoTrecho =
					action.payload.conexao.conexaoIda.trecho[
						action.payload.conexao.ordemViagemIda - 1
					]

				var poltronaDeselecionada = state.poltronasIda.filter(
					(e) =>
						e.number == action.payload.busSeat &&
						e.conexao == conexaoTrecho
				)

				var poltronasIdaFree = state.poltronasIda.filter(
					(e) => e !== poltronaDeselecionada[0]
				)

				var busSeatsGoing = state.busSeatsGoing.map((item) =>
					item.number === action.payload.busSeat
						? ((item.available = true && item.conexao === conexaoTrecho),
						  delete item.transactionId,
						  delete item.bookingCode,
						  delete item.price,
						  delete item.withInsurance,
						  delete item.conexao,
						  delete item.ordem,
						  item)
						: item
				)

				return {
					...state,
					poltronasIda: poltronasIdaFree,
					busSeatsGoing: busSeatsGoing,
				}
			}

			let poltronasSelectedIda = state.poltronasIda.filter(
				(e) => e.number != action.payload.busSeat
			)

			return {
				...state,
				poltronasIda: poltronasSelectedIda,
				busSeatsGoing: state.busSeatsGoing.map((item) =>
					item.number === action.payload.busSeat
						? ((item.available = true),
						  delete item.transactionId,
						  delete item.bookingCode,
						  delete item.price,
						  delete item.withInsurance,
						  item)
						: item
				),
			}

		case busSeatSelectionConstants.SELECT_BUS_SEAT_RETURN:
			let seatBusSelectedReturn = action.payload
			let newBusSeatsReturn = []

			let updatedBusSeatsReturn = state.busSeatsReturn.map((seat) => {
				if (seat.number === seatBusSelectedReturn.number) {
					let updatedSeat = {
						...seat,
						...seatBusSelectedReturn,
						available: false,
					}

					if (!!seatBusSelectedReturn.conexao) {
						updatedSeat.dataViagem =
							seatBusSelectedReturn.conexao.departure
						updatedSeat.ordem = seatBusSelectedReturn.conexao.ordem
					}

					newBusSeatsReturn.push(updatedSeat)

					return updatedSeat
				}

				return seat
			})

			return {
				...state,
				busSeatsReturn: updatedBusSeatsReturn,
				poltronasVolta: [...state.poltronasVolta, ...newBusSeatsReturn],
			}

		case busSeatSelectionConstants.DESELECT_BUS_SEAT_RETURN:
			const { conexao } = action.payload

			if (conexao && conexao.ehConexaoVolta) {
				var conexaoTrecho =
					action.payload.conexao.conexaoVolta.trecho[
						action.payload.conexao.ordemViagemVolta - 1
					]

				let poltronaDeselecionada = state.poltronasVolta.filter(
					(poltronaVolta) =>
						poltronaVolta.number == action.payload.busSeat &&
						poltronaVolta.conexao == conexaoTrecho
				)

				let poltronasVolta = state.poltronasVolta.filter(
					(e) => e !== poltronaDeselecionada[0]
				)

				let busSeatsReturn = state.busSeatsReturn.map((item) =>
					item.number === action.payload.busSeat
						? ((item.available = true),
						  delete item.transactionId,
						  delete item.bookingCode,
						  delete item.price,
						  delete item.withInsurance,
						  delete item.conexao,
						  delete item.ordem,
						  item)
						: item
				)

				return {
					...state,
					poltronasVolta: poltronasVolta,
					busSeatsReturn: busSeatsReturn,
				}
			}

			let poltronasSelectedVolta = state.poltronasVolta.filter(
				(e) => e.number != action.payload.busSeat
			)

			return {
				...state,
				poltronasVolta: poltronasSelectedVolta,
				busSeatsReturn: state.busSeatsReturn.map((item) =>
					item.number === action.payload.busSeat
						? ((item.available = true),
						  delete item.transactionId,
						  delete item.bookingCode,
						  delete item.price,
						  delete item.withInsurance,
						  item)
						: item
				),
			}
		case busSeatSelectionConstants.LOAD_BUS_SEATS_GOING:
			return {
				...state,
				busSeatsGoing: action.payload,
			}
		case busSeatSelectionConstants.LOAD_BUS_SEATS_RETURN:
			return {
				...state,
				busSeatsReturn: action.payload,
			}
		case busSeatSelectionConstants.SET_TOTAL_SEATS_GOING:
			return {
				...state,
				totalSeatsGoing: action.payload,
			}
		case busSeatSelectionConstants.SET_TOTAL_SEATS_RETURN:
			return {
				...state,
				totalSeatsReturn: action.payload,
			}
		case busSeatSelectionConstants.RESET:
			return initialState

		case busSeatSelectionConstants.SET_ORDEM_VIAGEM_IDA:
			return {
				...state,
				ordemViagemIda: action.payload,
			}
		default:
			return state
	}
}
